import { render, staticRenderFns } from "./CartThankYou.vue?vue&type=template&id=fbb478e8&scoped=true"
import script from "./CartThankYou.vue?vue&type=script&setup=true&lang=js"
export * from "./CartThankYou.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartThankYou.vue?vue&type=style&index=0&id=fbb478e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb478e8",
  null
  
)

export default component.exports